<template>
  <header class="header" ref="Header">
    <Progress v-show="$store.state.progress" />
    <main>
      <div class="top_header">
        <a-row>
          <a-col :span="6"><img @click="$router.$push('/home')" :src="require('@/assets/images/logo/logo.png')"></a-col>
          <a-col class="right_breadcrumb" :span="18">
            <AntBreadcrumb :data="data" separator="|" :select="select" @click="submit" />
            <div class="header_user">
              <User />
            </div>
          </a-col>
        </a-row>
      </div>
      <Navigation />
    </main>
  </header>
</template>

<script>
import User from './user';
import Navigation from './navigation';
import Progress from './progress';
export default {
  components: { User, Navigation, Progress },
  data() {
    return {
      data: [],
      select: "chinese"
    }
  },
  watch: {
    '$route': {
      deep: true,
      handler: function () {
        this.getRouter();
      }
    }
  },
  created() {
    this.setData();
    this.getRouter();
  },
  methods: {
    submit({ value = null, router = null, mode = [] }) {
      if (mode) {
        this.$FN.limitsTips({ list: mode, key: "some" }).then(res => res && router && this.$router.$push(router));
      } else {
        this.select = value;
        router && this.$router.$push(router);
      }
    },
    getRouter() {
      this.select = this.$route.path;
    },
    setData() {
      let list = [
        {
          label: "消息",
          value: "/message",
          router: "/message",
          rolesKey: "messagecenter",
          mode: ["messagecenter_skip"],
          icon: "icon-wjjf_icon_line_xiaoxi",
        },
        {
          label: "需求反馈",
          value: "/feedback",
          router: "/feedback",
          rolesKey: "demand_feedback",
          mode: ["demand_feedback_skip"],
          activeStyle: { color: '#0068B7' }
        },
        {
          label: "中文版",
          value: "chinese",
          style: { color: '#ae2024' }
        }
      ];
      this.data = this.$FN.filterLimitsVisible({ data: list });
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>